import { render, staticRenderFns } from "./Tiles.vue?vue&type=template&id=0736aa04&functional=true&"
import script from "./Tiles.vue?vue&type=script&lang=ts&"
export * from "./Tiles.vue?vue&type=script&lang=ts&"
import style0 from "./Tiles.vue?vue&type=style&index=0&id=0736aa04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports